import { getAxiosConfig } from "@/services/axiosConfig";
import {
  IBestSellerDataGeneric,
  IBestSellers,
  IBrandsGeneric,
} from "global-types/global.types";
import { useQuery } from "react-query";

export default function useBestSeller(slug: string[]) {
  const { data: bestSeller, isLoading: isLoadingBestSeller } = useQuery(
    ["BEST_SELLER", slug],
    async () => {
      if (!slug) return null;

      const res = await getAxiosConfig().get<
        IBestSellers<IBestSellerDataGeneric<IBrandsGeneric>[]>
      >(`/category/product?category_id=${slug}&take=3&bestseller=1`);

      return res.data;
    }
  );

  return { bestSeller, isLoadingBestSeller };
}
